module.exports = __webpack_public_path__ + "img/vertical_2_1_5010.50b12c9f.png";